import SingleOfferTemplate from '../../../component/template/SingleOfferTemplate.js'
import Webview from "../../../component/native/visible/Webview";
import PlayerView from "../../../component/native/visible/PlayerView";
import App from "../../../App";
import {getFilePathByRemoteUrl} from '@src/common/util'
import Dialog from "../../../component/visible/Dialog"
import SimpleBanner from "../../../component/visible/SimpleBanner"
import Message from '../../../../class/Message'
import jsBridge from "../../../../common/jsBridge";



class TaskNode {
    constructor(props) {
        const { id, type, taskMap, next } = props
        this.id = id
        this.type = type
        this.taskMap = taskMap
        this.next = next
    }

    start(data){
        this.preTask()
        this.doTask()
        this.afterTask()

        if(this.next){
            this.gotoNode(this.next)
        }
    }

    preTask(){}
    doTask(){}
    afterTask(){}
    gotoNode(nodeId, params, color='cadetblue'){
        console.log(`%c由节点 ${this.id} 跳转到节点 ${nodeId} `, `color: ${color};font-size: 18px;font-weight: bold;text-decoration: underline;`)
        const node = this.taskMap[nodeId]
        node.start(params)
    }
}


class DefaultNode extends TaskNode {
    constructor(props) {
        super(props)
        const { fnName, params, then } = props
        this.fnName = fnName
        this.params = params
        this.then = then
    }

    preTask(){

    }

    doTask(){
        console.log('节点 '+this.id+' 调用SDK方法====》'+this.fnName, this.params)

        const ret = jsBridge.callNative({fnName: this.fnName, params: this.params})

        /*const ret = new Promise((resolve, reject)=>{
            resolve()
        })*/

        ret.then(res=>{
            if(this.then){
                this.gotoNode(this.then)
            }
        })
        return ret
    }

    afterTask(){

    }
}

class SwitchNode extends TaskNode {
    constructor(props) {
        super(props)
        const { switchList=[] } = props
        // const { getResult, whenTrue, whenFalse } = props
        this.switchList = switchList
    }
    preTask(){

    }

    doTask(){
        this.switchList.forEach(item=>{
            const { getResult, whenTrue, whenFalse } = item

            const ret = eval(getResult)
            const next = !!ret ? whenTrue : whenFalse
            const node = this.taskMap[next]
            node.start()
        })
    }

    afterTask(){

    }
}

class ForEachNode extends TaskNode {
    constructor(props) {
        super(props)
        const { count, goto, afterEach } = props
        this.count = count
        this.goto = goto
        this.afterEach = afterEach
    }

    preTask(){

    }

    doTask(){
        this.count--
        //console.log('循环节点 this.count====>',this.count, this.goto)
        if(this.count >=0){
            this.gotoNode(this.goto, undefined, 'cornflowerblue')
        }else {
            console.log('循环节点结束====>')
            this.gotoNode(this.afterEach)
        }
    }

    afterTask(){

    }
}



const TASK_TYPE = {
    DEFAULT: 'default',
    SWITCH: 'switch',
    FOR_EACH: 'forEach'
}


export default class ApiListDemo extends SingleOfferTemplate {
    constructor(...props) {
        super(...props)


        this.taskList = [{
            id: 1,
            type: 'default',
            fnName: 'fn1',
            params: {},
            then: 2, //异步下一个
            next: 3 //同步下一个
        }, {
            id: 2,
            type: 'default',
            fnName: 'fn2',
            params: {},
        }, {
            id: 3,
            type: 'default',
            fnName: 'fn3',
            params: {},
            next: 4 //同步下一个
        }, {
            id: 4,
            type: 'default',
            fnName: 'fn4',
            params: {},
            next: 5 //同步下一个
        }, {
            id: 5,
            type: 'forEach',
            count: 5,
            goto: 4,
            afterEach: 6 //遍历结束后的下一个
        }, {
            id: 6,
            type: 'default',
            fnName: 'fn6',
            params: {},
            next: 7 //同步下一个
        }, {
            id: 7,
            type: 'default',
            fnName: 'fn7',
            params: {},
        }]


        /*this.taskList = [{
            id: 1,
            type: 'default',
            fnName: 'VideoBridge/createWebview',
            params: {},
            then: 2, //异步下一个
            next: 3 //同步下一个
        }, {
            id: 2,
            type: 'default',
            fnName: 'VideoBridge/createWebview',
            params: {},
        }, {
            id: 3,
            type: 'default',
            fnName: 'VideoBridge/createWebview',
            params: {},
            next: 4 //同步下一个
        }, {
            id: 4,
            type: 'default',
            fnName: 'VideoBridge/createWebview',
            params: {},
            next: 5 //同步下一个
        }, {
            id: 5,
            type: 'forEach',
            count: 5,
            goto: 4,
            afterEach: 6 //便利结束后的下一个
        }, {
            id: 6,
            type: 'default',
            fnName: 'VideoBridge/createWebview',
            params: {},
            next: 7 //同步下一个
        }, {
            id: 7,
            type: 'default',
            fnName: 'VideoBridge/createWebview',
            params: {},
        }]*/





        this.initTask()
    }

    initTask() {
        const taskMap = {}
        let nodeClass
        this.taskList.forEach(item=>{
            switch(item.type){
                case TASK_TYPE.SWITCH:
                    nodeClass = SwitchNode
                    break
                case TASK_TYPE.FOR_EACH:
                    nodeClass = ForEachNode
                    break
                default:
                    nodeClass = DefaultNode
            }
            taskMap[item.id] = item
            item.taskMap = taskMap
            taskMap[item.id] = new nodeClass(item)
        })
        console.log('Begin => taskMap======>',taskMap)
        console.log('+========================================================================+')
        console.log('+========================================================================+')
        console.log('+========================================================================+')
        console.log('')
        taskMap[this.taskList[0].id].start()
    }


    initComponents() {
        //super.initComponents()


    }

    adShowed() {
        super.adShowed()
    }

    bindPageEvent() {
        //super.bindPageEvent()
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {

    }

    initSlots() {
        //super.initSlots()

    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        return Promise.all([
            super._isLoadFinish()
        ])
    }
}